// @flow
import React, { type Node } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import stylesButton from '../CustomLink/styles.module.scss';
import styles from './styles.module.scss';

const getTarget = (external, onLanding) => {
  if (external && onLanding) {
    return { target: '_self' };
  }
  if (external) {
    return { target: '_blank' };
  }
  return {};
};

type Props = {
  name?: string,
  use?: string,
  outlined?: boolean,
  fill?: boolean,
  small?: boolean,
  transparent?: boolean,
  children?: Node,
  className?: string,
  containsIcon?: boolean,
  to: string,
  external?: boolean,
  onClick?: (boolean) => void,
  onLanding?: boolean,
};

const LinkButton = ({
  name = '',
  use = 'primary',
  outlined,
  fill = false,
  small = false,
  transparent = false,
  containsIcon = false,
  external = true,
  onLanding = false,
  children,
  className = '',
  to,
  onClick,
}: Props) => {
  const Component = external ? 'a' : Link;
  const anchor: 'to' | 'href' = external ? 'href' : 'to';
  const additionalProps = getTarget(external, onLanding);
  const Inner = (
    <span className={classnames(stylesButton.buttonContent)}>
      {children || name}
    </span>
  );

  // eslint-disable-next-line react/no-children-prop
  return React.createElement(Component, {
    [anchor]: to,
    onClick,
    className: classnames(
      stylesButton.customLink,
      stylesButton.customLinkText,
      stylesButton[use],
      styles.link,
      {
        [stylesButton.outlined]: outlined,
        [stylesButton.fill]: fill,
        [stylesButton.small]: small,
        [stylesButton.transparent]: transparent,
        [stylesButton.icon]: containsIcon,
      },
      className,
    ),
    children: Inner,
    ...additionalProps,
  });
};

export default LinkButton;
